"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var style = __importStar(require("./Paper.style"));
var theme_1 = require("@prezzee/theme");
var Paper = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'div' : _a, _b = props.elevation, elevation = _b === void 0 ? 'sm' : _b, role = props.role, _c = props.square, square = _c === void 0 ? false : _c, _d = props.variant, variant = _d === void 0 ? 'elevation' : _d, other = __rest(props, ["children", "className", "component", "elevation", "role", "square", "variant"]);
    var ownerState = __assign(__assign({}, props), { component: component, elevation: elevation, square: square, variant: variant });
    // if (process.env.NODE_ENV !== 'production') {
    //   // eslint-disable-next-line react-hooks/rules-of-hooks
    //   const theme = useTheme();
    //   if (theme.shadows[elevation] === undefined) {
    //     console.error(
    //       [
    //         `The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
    //         `Please make sure that \`theme.shadows[${elevation}]\` is defined.`,
    //       ].join('\n'),
    //     );
    //   }
    // }
    var PaperRoot = component;
    // TODO: add ref here
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(PaperRoot, __assign({ css: style.root(ownerState, theme), className: className, ref: ref, role: role }, other, { children: children })));
});
exports.default = Paper;
//# sourceMappingURL=Paper.js.map